import React from "react";
import { Button } from "../../Common/Button";

interface IProps {
    maxHeight: string | number;
    maxWidth: string | number;
    onClose(): void;
    children: React.ReactNode;
}

export const ModalUI: React.FC<IProps> = ({ children, maxHeight, maxWidth, onClose }) => {
    return <div className="h-dvh w-dvw top-0 left-0 absolute box-border z-40 overlay flex justify-center items-center">
        <div
            className={`bg-antiqueWhite absolute h-full w-full box-shadow box-border flex justify-evenly flex-col items-center heavy-border`}
            style={{ maxWidth, maxHeight }}
        >
            <div className="h-[6px] w-[6px] bg-black absolute left-0 top-0" />
            <div className="h-[6px] w-[6px] bg-black absolute z-20 right-0 top-0" />
            <div className="h-[6px] w-[6px] bg-black absolute left-0 bottom-0" />
            <div className="h-[6px] w-[6px] bg-black absolute right-0 bottom-0" />
            <Button
                variant="text"
                text="X"
                onClick={onClose}
                className="border-none shadow-none absolute right-2 top-2 w-10 h-10 text-sm bg-antiqueWhite"
            />
            {children}
        </div>
    </div>
}